import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Products data for dropdown
  const products = [
    {
      id: 1,
      name: 'HEMA-CORDIAL',
      category: 'womens-health'
    },
    {
      id: 2,
      name: 'GASSO-WIN',
      category: 'digestive-health'
    },
    {
      id: 3,
      name: 'VITAL COMPOUND',
      category: 'liver-health'
    },
    {
      id: 4,
      name: 'COUGH-CO',
      category: 'respiratory-care'
    },
    {
      id: 5,
      name: 'LIVWIN',
      category: 'liver-health'
    },
    {
      id: 6,
      name: 'ACHE-WIN OIL',
      category: 'pain-relief'
    },
    {
      id: 7,
      name: 'VITAL DROPS (Pediatric)',
      category: 'pediatric-care'
    },
    {
      id: 8,
      name: 'DYLOWIN TABLET',
      category: 'diabetes-care'
    }
  ];

  const handleProductClick = (productId) => {
    window.location.href = `/product/${productId}`;
  };

  return (
    <>
      <div className="announcement-bar">
        <div className="container">
          <p>Experience the power of natural wellness, delivered straight to your door</p>
        </div>
      </div>
      
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <img src="/photos/SAP logo new.png" alt="Shiv Ayurvedic Pharmacy Logo" />
              <div>
                <h2>Shiv Ayurvedic Pharmacy</h2>
                <span className="gmp-badge">G.M.P. Certified</span>
              </div>
            </div>
            
            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
              <ul className="nav-list" onClick={() => setIsMenuOpen(false)}>
                <li><a href="/">Home</a></li>
                <li className="dropdown">
                  <a href="/products.html">Products</a>
                  <div className="dropdown-content">
                    {/* Previous Categories - Commented Out
                    <a href="#womens-health">Women's Health</a>
                    <a href="#digestive-health">Digestive Health</a>
                    <a href="#respiratory-care">Respiratory Care</a>
                    <a href="#liver-health">Liver Health</a>
                    <a href="#pain-relief">Pain Relief</a>
                    <a href="#pediatric-care">Pediatric Care</a>
                    <a href="#diabetes-care">Diabetes Care</a>
                    */}

                    {/* Product Items */}
                    {products.map((product) => (
                      <a
                        key={product.id}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleProductClick(product.id);
                        }}
                      >
                        {product.name}
                      </a>
                    ))}
                  </div>
                </li>
                <li><a href="/about.html">About</a></li>
                {/* <li><a href="#blog">Blog</a></li> */}
                <li><a href="/contact.html">Contact</a></li>
              </ul>
            </nav>
            
            {/* <div className="header-actions">
              <button className="search-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <button className="account-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <button className="cart-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.7 15.3C4.3 15.7 4.6 16.5 5.1 16.5H17M17 13V17C17 18.1 16.1 19 15 19H9C7.9 19 7 18.1 7 17V13H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="cart-count">0</span>
              </button>
            </div> */}
            
            <button className="mobile-menu-btn" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;